import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Tooltip, Icon } from '@shopify/polaris';
import { QuestionMarkMinor } from '@shopify/polaris-icons';

const propTypes = {
  columnsInfo: PropTypes.array.isRequired,
};

const defaultProps = { }

const TableHeaders = (props) => (
  <div className="container-fluid pt15 pb15 resource-header">
    <div className="row">
      { props.columnsInfo.map ( ( col, index) => 
        <div key={index} className={ `col-12 col-md-${ col.size } `}>
          { col.tooltip && 
            <Tooltip content={col.tooltip}>
              <span>{ col.header }</span>
              <Icon source={QuestionMarkMinor} color="base"
                accessibilityLabel={col.tooltip} />
            </Tooltip>
          }
          { !col.tooltip &&
            <span>{ col.header }</span>
          }
        </div>
      )}
    </div>
  </div>
)

TableHeaders.propTypes = propTypes;
TableHeaders.defaultProps = defaultProps;

export default TableHeaders;